import { Component, HostListener, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { DeliveryService } from '../../../../services/delivery';
import { ItemsService } from '../../../../services/items.service';

@Component({
  selector: 'app-deliverymanagerpagemobile',
  templateUrl: './deliverymanagerpagemobile.component.html',
  styleUrl: './deliverymanagerpagemobile.component.scss'
})
export class DeliverymanagerpagemobileComponent implements OnInit {

  allData: any[] = [];
  allWareHouses: any[] = [];

  isAr: boolean = localStorage.getItem('language') === 'ar';

  contentReady: boolean = true;
  loadingMore: boolean = false;
  noData: boolean = false;
  searched: boolean = false;

  accountType!: string;
  isAdmin: boolean = false;
  isSubAdmin: boolean = false;

  warehouseId: any = null;
  selectedWarehouseName: string = '';

  page: number = 1;
  totalItems: number = 1;
  stockTotal: number = 0;

  private isFetching: boolean = false;

  constructor(
    private _userService: UserService,
    private _deliveryhero: DeliveryService,
    private _ItemsService: ItemsService
  ) {}

  ngOnInit(): void {
    this.warehouseId = localStorage.getItem('posId');

    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType === '1' || this.accountType === '10';
        this.isSubAdmin = this.accountType === '6';

        if (this.isAdmin || this.isSubAdmin) {
          this.getAllHeros(this.warehouseId, true, 1, true);
        }
      },
      error: (error) => console.error(error),
    });

    this.getWarehouses();
  }

  getWarehouses(): void {
    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res?.warehouse || [];
        this.setSelectedWarehouseName();
      },
      error: (err) => console.error(err),
    });
  }

  applyWareHouse(warehouseId: any): void {
    this.warehouseId = warehouseId;
    this.page = 1;
    this.setSelectedWarehouseName();
    this.getAllHeros(this.warehouseId, true, 1, true);
  }

  setSelectedWarehouseName(): void {
    const selected = this.allWareHouses.find((el: any) => el.id == this.warehouseId);
    this.selectedWarehouseName = selected?.name || '';
  }

  getAllHeros(
    warehouse: any,
    hasPagination: boolean = true,
    page: number = 1,
    reset: boolean = true
  ): void {
    if (this.isFetching) return;

    this.isFetching = true;
    this.searched = false;

    if (reset) {
      this.contentReady = true;
      this.loadingMore = false;
    } else {
      this.loadingMore = true;
    }

    this._deliveryhero.getAllDeliveryStars(warehouse, hasPagination, page).subscribe({
      next: (data) => {
        const rows = data?.data || [];

        if (reset) {
          this.allData = rows;
        } else {
          this.allData = [...this.allData, ...rows];
        }

        this.page = page;
        this.stockTotal = data?.total || this.allData.length;
        this.totalItems = data?.last_page || 1;

        this.noData = this.allData.length === 0;

        this.contentReady = false;
        this.loadingMore = false;
        this.isFetching = false;
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
        this.loadingMore = false;
        this.isFetching = false;
      },
    });
  }

  get canLoadMore(): boolean {
    return this.page < this.totalItems;
  }

  loadMore(): void {
    if (!this.canLoadMore || this.isFetching) return;

    this.getAllHeros(this.warehouseId, true, this.page + 1, false);
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    const bottomReached = scrollPosition + windowHeight >= pageHeight - 120;

    if (bottomReached && this.canLoadMore && !this.isFetching && !this.contentReady) {
      this.loadMore();
    }
  }

  deleteitem(id: string): void {
    Swal.fire({
      title: this.isAr ? 'متأكد؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'اه' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'NO',
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;

        this._deliveryhero.deleteDeliveryStar(id).subscribe({
          next: () => {
            this.page = 1;
            this.getAllHeros(this.warehouseId, true, 1, true);
          },
          error: (err) => {
            console.error(err);
            this.contentReady = false;
          },
        });
      }
    });
  }

  // Alias لو في أي HTML قديم لسه بينادي deleteuser
  deleteuser(id: string): void {
    this.deleteitem(id);
  }

  getHeroImage(element: any): string {
    const image = element?.image_url || element?.image;

    if (!image) return '';

    if (/^https?:\/\//i.test(image)) {
      return image.replace('/storage/', '/storage/app/public/');
    }

    return `https://backendproduction.blueboxpet.com/storage/app/public/${image}`;
  }

  getInitial(name: any): string {
    if (!name) return '?';
    return String(name).trim().charAt(0).toUpperCase();
  }

  go(url: string): void {
    if (!url) return;

    if (typeof window !== 'undefined') {
      window.open(url, '_blank');
    }
  }

  trackByHeroId(index: number, item: any): any {
    return item?.id || index;
  }
}